// components/LoadingState.js
import React from "react";
import { Loader } from "lucide-react";

// Loading component
const LoadingState = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "16rem", // equivalent to h-64
    }}
  >
    <Loader
      style={{
        width: "3rem", // equivalent to w-12
        height: "3rem", // equivalent to h-12
        color: "#3b82f6", // equivalent to text-blue-500
        marginBottom: "1rem", // equivalent to mb-4
        animation: "spin 1s linear infinite", // equivalent to animate-spin
      }}
    />
    <p
      style={{
        color: "#4b5563", // equivalent to text-gray-600
        fontSize: "1rem",
        fontWeight: "400",
      }}
    >
      Loading news articles...
    </p>
  </div>
);

export default LoadingState;
